import { useReducer } from 'react';

const getInitialState = callbacks => {
  return {
    data: new Array(callbacks.length).fill({
      data: undefined,
      error: undefined,
      isLoading: false,
      isLoaded: false
    }),
    isLoaded: false,
    isLoading: false
  };
};

const getActionTypes = prefix => {
  prefix = prefix ? `${prefix}:` : '';

  return {
    LOAD: `Action: ${prefix}:LOAD`,
    LOAD_SUCCESS: `Action: ${prefix}:LOAD_SUCCESS`,
    LOAD_FAILURE: `Action: ${prefix}:LOAD_FAILURE`
  };
};

const insert = (array, value, index) => {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
};

const getReducer = actionTypes => (oldState, action) => {
  switch (action.type) {
    case actionTypes.LOAD:
      return {
        ...oldState,
        data: oldState.data.map(datum => ({
          ...datum,
          isLoading: true
        })),
        isLoading: true
      };

    case actionTypes.LOAD_SUCCESS: {
      const data = insert(
        oldState.data,
        {
          data: action.payload.data,
          isLoading: false,
          isLoaded: true,
          error: undefined
        },
        action.payload.index
      );

      return {
        data,
        isLoading: data.some(d => d.isLoading),
        isLoaded: data.every(d => d.isLoaded)
      };
    }
    case actionTypes.LOAD_FAILURE: {
      console.warn(`[${action.type}]:`, action.payload); // eslint-disable-line no-console

      const data = insert(
        oldState.data,
        {
          data: undefined,
          isLoading: false,
          isLoaded: false,
          error: action.payload.error
        },
        action.payload.index
      );

      return {
        data,
        isLoading: data.some(d => d.isLoading),
        isLoaded: data.every(d => d.isLoaded)
      };
    }
    default:
      throw new Error(`Unrecognized action: ${action.type}`);
  }
};

const getUseLoad = actionTypes => dispatch => payload =>
  dispatch({ type: actionTypes.LOAD, payload });

const applyMiddleware = (dispatch, actionTypes, callbacks) => action => {
  dispatch(action);//call load action with no payload

  if (action.type !== actionTypes.LOAD) {
    return;
  }

  callbacks.forEach((callback, index) => {
    if (typeof callback !== 'function') {
      dispatch({
        type: actionTypes.LOAD_FAILURE,
        payload: { error: new Error('Invalid callback'), index }
      });
      return;
    }

    let result;
    try {
      result = callback(action.payload);
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FAILURE, payload: { error, index } });
      return;
    }

    if (result && typeof result.then === 'function') {
      result
        .then(data =>
          dispatch({ type: actionTypes.LOAD_SUCCESS, payload: { data, index } })
        )
        .catch(error =>
          dispatch({
            type: actionTypes.LOAD_FAILURE,
            payload: { error, index }
          })
        );
    } else {
      dispatch({
        type: actionTypes.LOAD_SUCCESS,
        payload: { data: result, index }
      });
    }
  });
};

const useLoadableBulk = ({ callbacks = [], actionPrefix }) => {
  const actionTypes = getActionTypes(actionPrefix);

  const useLoad = getUseLoad(actionTypes);

  const [state, dispatch] = useReducer(
    getReducer(actionTypes),
    getInitialState(callbacks)
  );
  const load = useLoad(applyMiddleware(dispatch, actionTypes, callbacks));

  return { ...state, load };
};

export default useLoadableBulk;
